import type { ReactNode } from 'react';
import { Svg } from '../../primitives/Svg.js';
import { useDecorativeIconMotion } from '../../primitives/useIconMotion.js';
import type { IconProps } from '../../primitives/types.js';

/** Heart — double-tap heartbeat (systole + diastole) with a soft radial pulse.
 *  Timing is 1.2s (≈50 bpm, calm). `transform-origin: 8 8` keeps scaling centered. */
export function IcnHeart(props: IconProps): ReactNode {
  const animate = useDecorativeIconMotion();
  return (
    <Svg {...props} iconName="heart">
      {animate && (
        <circle cx="8" cy="8" r="5" fill="currentColor" stroke="none" opacity="0">
          <animate
            attributeName="r"
            values="5;7.5"
            keyTimes="0;1"
            dur="1.2s"
            repeatCount="indefinite"
          />
          <animate
            attributeName="opacity"
            values="0.28;0"
            keyTimes="0;1"
            dur="1.2s"
            repeatCount="indefinite"
          />
        </circle>
      )}
      <path
        d="M8 13.3S2.5 10 2.5 6.4A3 3 0 0 1 8 4.6a3 3 0 0 1 5.5 1.8C13.5 10 8 13.3 8 13.3z"
        style={{ transformOrigin: '8px 8px' }}
      >
        {animate && (
          <animateTransform
            attributeName="transform"
            type="scale"
            keyTimes="0;0.1;0.22;0.34;0.5;1"
            values="1;1.14;1;1.07;1;1"
            dur="1.2s"
            repeatCount="indefinite"
            additive="sum"
          />
        )}
      </path>
    </Svg>
  );
}
